import React, { useState, useRef, useEffect } from "react";

// Generieke multi-select dropdown: knop met samenvattend label + een paneel
// met aanvinkbare opties. Sluit automatisch bij een klik buiten het paneel.
export default function MultiSelectDropdown({ label, options, selected, onChange, placeholder = "Alle" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggle = (value) => {
    if (selected.includes(value)) {
      onChange(selected.filter((v) => v !== value));
    } else {
      onChange([...selected, value]);
    }
  };

  const summary =
    selected.length === 0
      ? placeholder
      : selected.length === 1
      ? selected[0]
      : `${selected.length} geselecteerd`;

  return (
    <div className="relative" ref={ref}>
      {label && <label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>}
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full border border-gray-300 rounded px-2 py-1.5 text-sm text-left bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 flex justify-between items-center gap-1"
      >
        <span className={`truncate ${selected.length === 0 ? "text-gray-400" : "text-gray-700"}`}>
          {summary}
        </span>
        <span className="text-gray-400 shrink-0">▾</span>
      </button>

      {open && (
        <div className="absolute left-0 top-full mt-1 z-20 bg-white border border-gray-200 rounded-lg shadow-lg p-2 w-max min-w-[240px] max-h-64 overflow-y-auto">
          {options.length === 0 ? (
            <div className="text-xs text-gray-400 px-1 py-1">Geen opties</div>
          ) : (
            options.map((opt) => (
              <label
                key={opt}
                className="flex items-center gap-2 py-1 px-1 text-sm text-gray-700 cursor-pointer hover:bg-gray-50 rounded whitespace-nowrap"
              >
                <input
                  type="checkbox"
                  checked={selected.includes(opt)}
                  onChange={() => toggle(opt)}
                  className="rounded border-gray-300"
                />
                {opt}
              </label>
            ))
          )}
          {selected.length > 0 && (
            <button
              type="button"
              onClick={() => onChange([])}
              className="mt-1 pt-1 border-t border-gray-100 w-full text-xs text-blue-600 hover:text-blue-800 text-center"
            >
              Wissen
            </button>
          )}
        </div>
      )}
    </div>
  );
}
